import React, { useState } from "react";
import PropTypes from "prop-types";
import { Navbar, Nav, NavItem, NavLink, Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Logo from "../common/Logo";
import { calculatorCategories } from "../../helpers/calculatorOptions";

const NavbarVertical = ({
  navbarStyle = "transparent",
  isCollapsed = false,
}) => {
  // Initialize with all categories expanded by default
  const [expandedItems, setExpandedItems] = useState(() => {
    const initialExpanded = {};
    calculatorCategories.forEach((category) => {
      initialExpanded[category.id] = true;
      if (category.children) {
        category.children.forEach((subcategory) => {
          initialExpanded[subcategory.id] = true;
        });
      }
    });
    return initialExpanded;
  });

  const toggleExpanded = (itemId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const renderNavItem = (item, level = 0) => {
    // Skip hidden items
    if (item.hidden) {
      return null;
    }

    const hasChildren = item.children && item.children.length > 0;
    const isExpanded = expandedItems[item.id];
    const paddingLeft = level * 1.1 + 1; // 1.5rem per level + base 1rem

    if (hasChildren) {
      // Filter out hidden children
      const visibleChildren = item.children.filter((child) => !child.hidden);

      // If no visible children, don't render this category
      if (visibleChildren.length === 0) {
        return null;
      }

      return (
        <NavItem key={item.id}>
          <NavLink
            className="dropdown-indicator"
            onClick={() => toggleExpanded(item.id)}
            style={{ paddingLeft: `${paddingLeft}rem` }}
          >
            <span className="nav-link-text">{item.label}</span>
            <FontAwesomeIcon
              icon={isExpanded ? faChevronDown : faChevronRight}
              className="ml-auto"
            />
          </NavLink>
          <Collapse isOpen={isExpanded}>
            <Nav className="flex-column">
              {visibleChildren.map((child) => renderNavItem(child, level + 1))}
            </Nav>
          </Collapse>
        </NavItem>
      );
    }

    return (
      <NavItem key={item.id}>
        <NavLink href={item.path} style={{ paddingLeft: `${paddingLeft}rem` }}>
          <span className="nav-link-text">{item.label}</span>
        </NavLink>
      </NavItem>
    );
  };

  return (
    <Navbar
      className={`navbar-vertical navbar-expand-xl navbar-${navbarStyle} ${
        isCollapsed ? "navbar-vertical-collapsed" : ""
      }`}
      expand="xl"
    >
      <div className="navbar-vertical-toggle">
        <Logo at="navbar-vertical" />
      </div>

      <Collapse navbar>
        <div className="navbar-vertical-content">
          <Nav className="navbar-nav flex-column">
            {calculatorCategories.map((category) => renderNavItem(category))}
          </Nav>
        </div>
      </Collapse>
    </Navbar>
  );
};

NavbarVertical.propTypes = {
  navbarStyle: PropTypes.string,
  isCollapsed: PropTypes.bool,
};

export default NavbarVertical;
